import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

export default function StudentNavLink() {
  const location = useLocation();
  const [isActive, setIsActive] = useState(false);
  useEffect(() => {
    setIsActive(location.pathname);
  }, [location.pathname]);
  return (
    <>
      <Link
        to={"/coursePlayer"}
        className={`${isActive === "/coursePlayer" && "font-bold"}`}
      >
        Course player
      </Link>
      <Link
        to={"/leaderboard"}
        className={`${isActive === "/leaderboard" && "font-bold"}`}
      >
        Leaderboard
      </Link>
    </>
  );
}
